import Validator from 'fastest-validator';
import slugify from 'slugify';
import 'isomorphic-fetch';
import makeActions from './makeActions';
import makeReducers from './makeReducers';
import makeActionTypes from './makeActionTypes';
import makeSyncActions from './makeSyncActions';
import defaultFetchAdapter from './defaultFetchAdapter';
export var instances = [];
var v = new Validator();
v.add('slug', function (value) {
  var expected = slugify(value);

  if (value !== expected) {
    return v.makeError('slug', expected, value);
  }

  return true;
});
var schema = {
  servicesDeclarations: {
    type: 'array',
    items: {
      type: 'object',
      props: {
        name: {
          type: 'slug'
        },
        url: {
          type: "url"
        },
        transformer: {
          type: 'function',
          optional: true
        },
        onError: {
          type: 'function',
          optional: true
        },
        onStartFetching: {
          type: 'function',
          optional: true
        },
        onStopFetching: {
          type: 'function',
          optional: true
        },
        onReceivesData: {
          type: 'function',
          optional: true
        },
        actionsDeclarations: {
          type: 'array',
          items: {
            type: 'object',
            props: {
              name: {
                type: 'string'
              },
              method: {
                type: 'string'
              }
            }
          }
        }
      }
    }
  }
};
export var makeRestServices = function makeRestServices(servicesDeclarations) {
  var fetchFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFetchAdapter(fetch);

  if (Array.isArray(servicesDeclarations) && servicesDeclarations.length === 0) {
    throw new Error();
  }

  var validationResult = v.validate({
    servicesDeclarations: servicesDeclarations
  }, schema);

  if (validationResult !== true) {
    throw new Error(JSON.stringify(validationResult));
  }

  var actionTypes = makeActionTypes(servicesDeclarations);
  var syncActions = makeSyncActions(servicesDeclarations, actionTypes);
  var instance = {
    actionTypes: actionTypes,
    syncActions: syncActions,
    actions: makeActions(servicesDeclarations, actionTypes, syncActions, fetchFunction),
    reducers: makeReducers(servicesDeclarations, actionTypes)
  };
  instances.push(instance);
  return instance;
};
export default makeRestServices;